import React, { createContext, useCallback, useContext, useState } from "react";
import { CheckCircle2, AlertCircle, Info, X } from "lucide-react";

const ToastContext = createContext(null);

let idCounter = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const dismiss = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const showToast = useCallback(
    (message, type = "success") => {
      const id = ++idCounter;
      setToasts((prev) => [...prev, { id, message, type }]);
      setTimeout(() => dismiss(id), 3800);
    },
    [dismiss]
  );

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <div className="fixed top-5 right-5 z-[100] flex flex-col gap-2 items-end">
        {toasts.map((t) => (
          <ToastItem key={t.id} toast={t} onDismiss={() => dismiss(t.id)} />
        ))}
      </div>
    </ToastContext.Provider>
  );
}

function ToastItem({ toast, onDismiss }) {
  const Icon = toast.type === "error" ? AlertCircle : toast.type === "info" ? Info : CheckCircle2;
  const iconColor = toast.type === "error" ? "text-[#EA4335]" : toast.type === "info" ? "text-[#1a73e8]" : "text-[#34A853]";
  return (
    <div className="animate-toast-in max-w-[calc(100vw-2.5rem)]">
      <div className="flex items-center gap-3 pl-4 pr-3 py-3 rounded-2xl shadow-lg bg-white dark:bg-[#303134] border border-[#dadce0] dark:border-[#3c4043] text-xs font-medium text-[#202124] dark:text-[#e8eaed] sm:max-w-sm">
        <Icon className={`w-4 h-4 shrink-0 ${iconColor}`} />
        <span>{toast.message}</span>
        <button onClick={onDismiss} className="ml-2 shrink-0 text-[#9aa0a6] hover:text-[#202124] dark:hover:text-white cursor-pointer">
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast must be used within a ToastProvider");
  return ctx;
}
